const colors = {
  main: "#145CE6",
  inputbg: "#EEEEEE",
};

export default colors;
